<template>
  <div>

    <h2>{{ $t('title.system-parameters') }}</h2>

    <el-row :gutter="40">

      <el-col :span="12" :md="12" :sm="24" :xs="24">

        <data-table
          model="system-parameters"
          :columns="['id', 'value']"
          @row-click="rowClick"
        />

      </el-col>

      <el-col :span="12" :md="12" :sm="24" :xs="24">

        <data-form
          v-if="selected"
          :entity="selected"
          model="system-parameters"
          :fields="fields"
          :cancel="false"
        />

      </el-col>
  </el-row>

  </div>
</template>

<script>
export default {
  name: 'system-parameter-list',
  data () {
    return {
      selected: null,
      fields: {
        'id': {
          disabled: true
        },
        'value': {
          required: true
        }
      }
    }
  },
  methods: {
    rowClick (row) {
      this.selected = row
    }
  }
}
</script>


// WEBPACK FOOTER //
// SystemParameterList.vue?be36296c